import * as types from "../constants/ActionTypes";

const tabChoice = localStorage.getItem("tabChoice")
  ? localStorage.getItem("tabChoice")
  : "nextCall";
const initialState = {
  isTabNextCallInfoActive: tabChoice === "nextCall" ? true : false,
  isTabWaitingInfoActive: tabChoice === "waitingInfo" ? true : false,
  isTabChatInfoActive: tabChoice === "chatInfo" ? true : false,
  queueLength: 0,
  standbyLength: 0,
  msgsStandby: 0,
};

const queueTabActive = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_NEXT_CALL_QUEUE_TAB:
      return {
        ...state,
        isTabNextCallInfoActive: action.isActive,
        isTabWaitingInfoActive: state.isTabWaitingInfoActive,
        isTabChatInfoActive: state.isTabChatInfoActive,
      };
    case types.CHANGE_WAITING_CALL_QUEUE_TAB:
      return {
        ...state,
        isTabNextCallInfoActive: state.isTabNextCallInfoActive,
        isTabWaitingInfoActive: action.isActive,
        isTabChatInfoActive: state.isTabChatInfoActive,
      };
    case types.CHANGE_CHAT_CALL_QUEUE_TAB:
      return {
        ...state,
        isTabNextCallInfoActive: state.isTabNextCallInfoActive,
        isTabWaitingInfoActive: state.isTabWaitingInfoActive,
        isTabChatInfoActive: action.isActive,
      };
    case types.SEND_QUEUE_STANDBY:
      return {
        ...state,
        queueLength: action.queue,
        standbyLength: action.standby,
        msgsStandby: action.msgsStandby,
      };
    default:
      return state;
  }
};

export default queueTabActive;
